import React, {PureComponent} from 'react';
import {BrowserRouter as Router, Link, Route, Switch} from "react-router-dom";
import './index.css'
import '../../App.css'
import {withTranslation} from 'react-i18next';
import Connect from "react-redux/es/connect/connect";
import LoginContainer from './login';
import RecoveryPasswordContainer from './recover';
import Logo from '../../assets/logo.png'
import {getItem, keys} from "../../localStorage";
import {debug} from "../../utility/functions";
import Loading from "../subComponents/GenericLoading/loading";

class AuthenticationComponent extends PureComponent {

	render() {
		const {t} = this.props;

		return (
			<Router>
				<div className='authentication-main-container'>
					<div className="authentication-logo-container">
						<Link to="/">
							<img className="authentication-logo" alt="logo" src={Logo}/>
						</Link>
					</div>
					{this.renderAuthenticationComponent()}
					{this.renderAuthenticationLoadingPageComponent()}
					<div className="authentication-main-container-copy-right">
						{t('AÇORIANO ORIENTAL') + ' © ' + new Date().getFullYear()}
					</div>
					<div className="authentication-main-container-background"/>
				</div>
			</Router>
		)
	}

	renderAuthenticationLoadingPageComponent = () => {
		const {loading} = this.props;

		if(getItem(keys.loggedIn) !== null && loading) {
			return(
				<div className='authentication-body-container-loading-page-container'>
					<Loading size='medium-spinner' color='white' />
					<div className='authentication-body-container-loading-page-container-message'>
						Iniciando a sessão...
					</div>
				</div>
			)
		}
	};

	renderAuthenticationComponent = () => {
		const {loading} = this.props;

		if(getItem(keys.loggedIn) === null || (getItem(keys.loggedIn) !== null && !loading)) {
			return(
				<div className="authentication-body-container">
					<div className="authentication-body-container-welcome-message-container">
						<div className="authentication-body-container-welcome-message-container-header">
							Bem-vindo!
						</div>
						<div className="authentication-body-container-welcome-message-container-message">
							<p/>
							<p>
								AO ESCOLAS é uma plataforma para os jornais escolares.
							</p>
							<p>
								Aqui a sua escola poderá publicar os seus próprios conteúdos e partilhar as suas
								atividades e eventos com o público em geral.
							</p>
							<p>
								Caso a sua escola queira aderir, contacte o Açoriano Oriental, através do
								endereço:
							</p>
							<p>
								<a style={{color: 'white'}}
								   href="mailto:escolas@acorianooriental.pt">escolas@acorianooriental.pt</a>
							</p>
						</div>
					</div>
					<div className="authentication-body-container-auth-container">
						<div className='authentication-body-container-auth-container-inner-container'>
							<Switch>
								<Route exact path="/login" component={LoginContainer}/>
								<Route exact path="/recovery-password" component={RecoveryPasswordContainer}/>
								<Route component={LoginContainer}/>
							</Switch>
						</div>
					</div>
				</div>
			)
		}

	}
}

const mapStateToProps = store => ({
	loggedIn: store.loginReducer.loggedIn,
	loading: store.loginReducer.loading,
});

export default (Connect(mapStateToProps, {})(withTranslation("translations")(AuthenticationComponent)));
